import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { openFile, byteSize, Translate, ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './excel-file.reducer';
import { IExcelFile } from 'app/shared/model/excel-file.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IExcelFileProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const ExcelFile = (props: IExcelFileProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { excelFileList, match, loading } = props;
  return (
    <div>
      <h2 id="excel-file-heading">
        <Translate contentKey="examsysApp.excelFile.home.title">Excel Files</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="examsysApp.excelFile.home.createLabel">Create new Excel File</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {excelFileList && excelFileList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.excelFile.file">File</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.excelFile.tableName">Table Name</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {excelFileList.map((excelFile, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${excelFile.id}`} color="link" size="sm">
                      {excelFile.id}
                    </Button>
                  </td>
                  <td>
                    {excelFile.file ? (
                      <div>
                        {excelFile.fileContentType ? (
                          <a onClick={openFile(excelFile.fileContentType, excelFile.file)}>
                            <Translate contentKey="entity.action.open">Open</Translate>
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {excelFile.fileContentType}, {byteSize(excelFile.file)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>{excelFile.tableName}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${excelFile.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${excelFile.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${excelFile.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="examsysApp.excelFile.home.notFound">No Excel Files found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ excelFile }: IRootState) => ({
  excelFileList: excelFile.entities,
  loading: excelFile.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ExcelFile);
